import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import Icon from '../icons/icon'
import { domains } from '../../services'

const ComplementaryButton = props =>
  <Link
    to={`/${props.domain}/${props.id}`}
    className={classNames('complementary-button', props.className)}
    onClick={props.onClick}
  >
    <span>
      {props.text}
    </span>
    {props.hasIcon ? <Icon name={props.iconName} /> : null}
  </Link>

ComplementaryButton.propTypes = {
  domain: PropTypes.oneOf(Object.values(domains)).isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  hasIcon: PropTypes.bool,
  iconName: PropTypes.string,
  text: PropTypes.string
}

export default ComplementaryButton



// WEBPACK FOOTER //
// ./src/ui/buttons/complementary-button.js